<template>
  <div
    class="search"
    :class="{
      'has-results': hits.length && searchQuery !== '',
    }"
  >
    <!-- Cerca -->
    <div class="search__input__wrap">
      <div class="search__input">
        <!-- Input -->
        <input
          class="search__input__field"
          type="text"
          ref="inputSearch"
          :placeholder="$t('form.searchPlaceholder')"
          @input="updateQuery"
        />

        <!-- Reset -->
        <button
          v-if="searchQuery !== ''"
          class="search__input__reset"
          @click="resetResearch()"
        >
          {{ $t('search.delete') }}
        </button>

        <!-- Ico -->
        <img
          class="search__input__ico"
          src="~/assets/img/ico/search-icon-mobile.svg?url"
          alt="Search"
          width="20"
          height="20"
        />
      </div>
    </div>

    <div
      class="search__wrap"
      :class="{
        'has-results': hits.length && searchQuery !== '',
      }"
    >
      <!-- Ricerche popolari -->
      <div
        class="search__popular"
        v-if="(!hits.length && popularSearch) || searchQuery === ''"
      >
        <div class="search__popular__header">
          <h3 class="search__title text-large is-bold">
            {{ $t('search.popularSearch') }}
          </h3>
          <ul class="search__popular__list text-big">
            <li v-for="(search, index) in popularSearch" :key="index">
              <button @click="setSearch(search)">{{ search }}</button>
            </li>
          </ul>
        </div>
      </div>

      <!-- Filtri -->
      <div
        v-if="facets.length && searchQuery !== ''"
        class="search__filters show-for-large"
      >
        <div class="search__filters__header">
          <h3 class="search__title text-large is-bold">
            {{ $t('search.filtersBy') }}
          </h3>
        </div>
        <FiltersAside
          :filters="facets"
          :staticFilters="staticFacets"
          @update:filters="onUpdateFilters"
        />
      </div>

      <!-- Risultati -->
      <div v-if="hits.length && searchQuery !== ''" class="search__results">
        <div class="search__results__header">
          <h3 class="search__title text-large is-bold">
            {{ $t('search.products') }}
          </h3>
        </div>

        <ul class="search__results__list">
          <li v-for="(item, index) in hits" :key="index">
            <div class="search__results__item">
              <ListingProductSearch :product="item" />
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup>
// import dataPlaceholder from './placeholder.js'

import { useStore } from '@/store/index.js'
import { debounce } from '~/assets/js/utils/general.js'
import { transformFacets } from '~/assets/js/utils/algolia.js'
import queries from '@/graphql/craft/queries/index.js'

const props = defineProps({
  indexes: {
    type: Array,
    default: () => [],
  },
})

const { configuration } = useStore()
const query = queries.craft.popularSearch
const variables = computed(() => ({
  site: configuration.site,
}))
const { data } = await useGraphql(query, variables)
const popularSearch = computed(() => {
  return data.value?.globalSet?.ricerchePopolari?.split(',')
})

const facetFilters = ref([])
const hitsPerPage = ref(20)
const searchQuery = defineModel('searchQuery', { default: '' })

const inputSearch = ref(null)

const updateQuery = debounce((event) => {
  searchQuery.value = event.target.value
}, 750)

const searchRequests = computed(() => {
  return props.indexes.reduce(
    (acc, indexName) => [
      ...acc,
      {
        indexName,
        query: searchQuery.value ?? '*',
        hitsPerPage: hitsPerPage.value,
        facets: ['*'],
        facetFilters: [...facetFilters.value],
        page: 0,
      },
    ],
    [],
  )
})

const { hits, facets, staticFacets } = await useAlgoliaListing({
  requests: searchRequests,
  fetchOnLoad: false,
})

// const { hits, facets } = dataPlaceholder

const onUpdateFilters = (filters) => {
  facetFilters.value = transformFacets(filters.selectedFilters)
}

const setSearch = (search) => {
  searchQuery.value = search
  inputSearch.value.value = search
}

const resetResearch = () => {
  searchQuery.value = ''
  inputSearch.value.value = ''
}

const focusInput = () => {
  if (inputSearch.value) {
    inputSearch.value.focus()
  }
}

defineExpose({ focusInput })
</script>

<style lang="scss">
@import './style.scss';
</style>
